import { Box, Flex } from "grid-styled";
import Media from "react-media";
import system from "system-components";

import theme from "pstat-anywhere/themes/policystat/theme";
import { H1 } from "pstat-design-system/text";

export const LoginFormContainer = system({
  is: "form",
  textAlign: "center"
});

export const LoginWrapper = system(
  {
    is: "article"
  },
  "space",
  "width"
);

const FlexWithHeight = system(
  {
    is: Flex
  },
  "height"
);

const BoxWithWidth = system(
  {
    is: Box
  },
  "maxWidth"
);

const LoginHeader = system({
  is: H1,
  color: "nova.nova-color-typography-base",
  fontSize: "30px",
  fontWeight: "500",
  mb: 40
});

const Logo = system({
  is: "img",
  width: "255px",
  maxWidth: "70%"
});

export const LoginContainer = ({ headerText, children }) => (
  <Media query={{ minWidth: theme.breakpoints[0] }}>
    {isDesktop => (
      <FlexWithHeight
        height="100%"
        flex={1}
        flexDirection={isDesktop ? "row" : "column"}
      >
        <BoxWithWidth
          flex={1}
          bg="nova.nova-header-color-secondary"
          maxWidth={isDesktop ? "50%" : "100%"}
        >
          <FlexWithHeight
            height="100%"
            justifyContent="center"
            alignItems="center"
          >
            <Logo
              src={`${window.S3_IMG_URL}rldatix-policy-management-logo-white.png`}
              alt="rldatix policy management logo"
            />
          </FlexWithHeight>
        </BoxWithWidth>
        <Box flex={1} bg="nova.nova-surfaces-color-workspace">
          <FlexWithHeight
            height="100%"
            justifyContent="center"
            alignItems="center"
          >
            <BoxWithWidth width="100%" maxWidth="404px" m={40}>
              <LoginHeader>{headerText}</LoginHeader>
              {children}
            </BoxWithWidth>
          </FlexWithHeight>
        </Box>
      </FlexWithHeight>
    )}
  </Media>
);
